import { render } from "./songs.vue?vue&type=template&id=4229e817&scoped=true"
import script from "./songs.vue?vue&type=script&lang=js"
export * from "./songs.vue?vue&type=script&lang=js"

import "./songs.vue?vue&type=style&index=0&id=4229e817&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4229e817"]])

export default __exports__